module.exports = __webpack_public_path__ + "static/img/hebyy.4d99098.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hebyy.png
// module id = qs+1
// module chunks = 0